<template>
  <div class="page-wrapper">
  <div class="row">
    <div class="col-md-6">
      <div class="role-container">
   
    <!-- Header -->
    <div class="page-header">
      <div>
        <h3>Role Privilege List</h3>
        <p>Manage role based access privileges</p>
      </div>

      <button class="save-btn">
        <i class="ti ti-device-floppy"></i>
        Save Changes
      </button>
    </div>

    <!-- Toolbar -->

    <div class="toolbar">

      <div class="role-select">
        <label>Role</label>

        <select class="form-select" style="font-size: 11px;padding:">
          <option>Administrator</option>
          <option>CRA</option>
          <option>Site User</option>
        </select>
      </div>

      <div class="search-box">
        <i class="ti ti-search"></i>

        <input
          type="text"
          placeholder="Search privileges..."
          v-model="search"
        >
      </div>

    </div>

    <!-- Buttons -->

    <div class="action-bar">

      <button
        class="outline-btn"
        @click="expandAll"
      >
        <i class="ti ti-chevrons-down"></i>

        Expand All
      </button>

      <button
        class="outline-btn"
        @click="collapseAll"
      >
        <i class="ti ti-chevrons-up"></i>

        Collapse All
      </button>

    </div>

    <!-- Tree -->

    <div class="tree-card">

      <div
        class="folder"
        v-for="folder in filteredTree"
        :key="folder.id"
      >

        <!-- Folder Header -->

        <div
          class="folder-header"
          @click="toggle(folder)"
        >

          <div class="folder-left">

            <i
              class="ti"
              :class="folder.open
              ? 'ti-chevron-down'
              : 'ti-chevron-right'"
            ></i>

            <input
              type="checkbox"
              v-model="folder.checked"
              @click.stop
            >

            <i
              class="ti folder-icon"
              :class="folder.open
              ? 'ti-folder-open'
              : 'ti-folder'"
            ></i>

            <span class="folder-title">

              {{ folder.name }}

            </span>

          </div>

          <span class="count">

            {{ folder.children.length }}

          </span>

        </div>

        <!-- Children -->

        <transition name="fade">

          <div
            v-show="folder.open"
            class="children"
          >

            <div
              class="child"
              v-for="child in folder.children"
              :key="child.id"
            >

              <input
                type="checkbox"
                v-model="child.checked"
              >

              <i class="ti ti-file-description"></i>

              <span>

                {{ child.name }}

              </span>

            </div>

          </div>

        </transition>

      </div>

    </div>

  </div>
    </div>
    <div class="col-md-6">
      
    </div>
  </div>
  </div>
</template>

<script>
import moduleListLogic from "./roles";
import "./roles.css";

export default moduleListLogic;
</script>